import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './MentorProfilesSubTab.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function generateRandomPassword(length = 10) {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789';
  let s = '';
  for (let i = 0; i < length; i++) {
    s += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return s;
}

function MentorProfilesSubTab() {
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [editingProfile, setEditingProfile] = useState(null);
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    social_link: '',
    technology: '',
    login: '',
    password: ''
  });

  useEffect(() => {
    fetchProfiles();
  }, []);

  const fetchProfiles = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/api/mentor-profiles`);
      setProfiles(response.data);
      setError(null);
    } catch (err) {
      setError('Ошибка при загрузке профилей менторов: ' + (err.response?.data?.detail || err.message));
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingProfile) {
        const payload = {
          first_name: formData.first_name,
          last_name: formData.last_name || null,
          social_link: formData.social_link || null,
          technology: formData.technology || null,
          login: formData.login
        };
        if (formData.password.trim()) {
          payload.password = formData.password;
        }
        await axios.put(`${API_URL}/api/mentor-profiles/${editingProfile.id}`, payload);
      } else {
        if (!formData.password.trim()) {
          setError('Введите пароль или сгенерируйте его');
          return;
        }
        await axios.post(`${API_URL}/api/mentor-profiles`, {
          first_name: formData.first_name,
          last_name: formData.last_name || null,
          social_link: formData.social_link || null,
          technology: formData.technology || null,
          login: formData.login,
          password: formData.password
        });
      }
      setShowForm(false);
      setEditingProfile(null);
      setFormData({ first_name: '', last_name: '', social_link: '', technology: '', login: '', password: '' });
      fetchProfiles();
      setError(null);
    } catch (err) {
      setError('Ошибка при сохранении: ' + (err.response?.data?.detail || err.message));
    }
  };

  const handleEdit = (profile) => {
    setEditingProfile(profile);
    setFormData({
      first_name: profile.first_name,
      last_name: profile.last_name || '',
      social_link: profile.social_link || '',
      technology: profile.technology || '',
      login: profile.login,
      password: ''
    });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Вы уверены, что хотите удалить этот профиль ментора?')) {
      try {
        await axios.delete(`${API_URL}/api/mentor-profiles/${id}`);
        fetchProfiles();
      } catch (err) {
        setError('Ошибка при удалении: ' + (err.response?.data?.detail || err.message));
      }
    }
  };

  const handleCancel = () => {
    setShowForm(false);
    setEditingProfile(null);
    setFormData({ first_name: '', last_name: '', social_link: '', technology: '', login: '', password: '' });
  };

  const handleGeneratePassword = () => {
    setFormData(prev => ({ ...prev, password: generateRandomPassword(10) }));
  };

  if (loading) {
    return <div className="loading">Загрузка...</div>;
  }

  return (
    <div className="mentor-profiles-sub-tab">
      <div className="tab-header">
        <h2>Профили менторов</h2>
        {!showForm && (
          <button className="btn btn-primary" onClick={() => setShowForm(true)}>
            + Добавить профиль
          </button>
        )}
      </div>

      {error && <div className="error-message">{error}</div>}

      {showForm && (
        <div className="form-container">
          <h3>{editingProfile ? 'Редактировать профиль ментора' : 'Добавить профиль ментора'}</h3>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="first_name">Имя ментора *</label>
              <input
                type="text"
                id="first_name"
                value={formData.first_name}
                onChange={(e) => setFormData({ ...formData, first_name: e.target.value })}
                required
                maxLength={255}
                placeholder="Введите имя"
              />
            </div>
            <div className="form-group">
              <label htmlFor="last_name">Фамилия ментора</label>
              <input
                type="text"
                id="last_name"
                value={formData.last_name}
                onChange={(e) => setFormData({ ...formData, last_name: e.target.value })}
                maxLength={255}
                placeholder="Введите фамилию (необязательно)"
              />
            </div>
            <div className="form-group">
              <label htmlFor="social_link">Ссылка на профиль в соцсети</label>
              <input
                type="url"
                id="social_link"
                value={formData.social_link}
                onChange={(e) => setFormData({ ...formData, social_link: e.target.value })}
                maxLength={500}
                placeholder="https://..."
              />
            </div>
            <div className="form-group">
              <label htmlFor="technology">Технология</label>
              <input
                type="text"
                id="technology"
                value={formData.technology}
                onChange={(e) => setFormData({ ...formData, technology: e.target.value })}
                maxLength={255}
                placeholder="Произвольный текст, например: Python Backend"
              />
            </div>
            <div className="form-group">
              <label htmlFor="login">Логин *</label>
              <input
                type="text"
                id="login"
                value={formData.login}
                onChange={(e) => setFormData({ ...formData, login: e.target.value })}
                required
                maxLength={255}
                placeholder="Логин для входа"
              />
            </div>
            <div className="form-group">
              <div className="form-group-label-row">
                <label htmlFor="password">
                  Пароль {!editingProfile && '*'}
                </label>
                <button
                  type="button"
                  className="btn btn-small btn-secondary"
                  onClick={handleGeneratePassword}
                  title="Сгенерировать случайный пароль из 10 символов"
                >
                  🔑 Сгенерировать пароль
                </button>
              </div>
              <input
                type="text"
                id="password"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                required={!editingProfile}
                maxLength={255}
                placeholder={editingProfile ? 'Оставьте пустым, чтобы не менять пароль' : 'Введите пароль или сгенерируйте'}
                autoComplete="off"
              />
            </div>
            <div className="form-actions">
              <button type="submit" className="btn btn-primary">
                {editingProfile ? 'Сохранить' : 'Создать'}
              </button>
              <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                Отмена
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Имя</th>
              <th>Фамилия</th>
              <th>Ссылка на профиль</th>
              <th>Технология</th>
              <th>Логин</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            {profiles.length === 0 ? (
              <tr>
                <td colSpan="7" className="empty-state">
                  Нет профилей менторов. Добавьте первый профиль.
                </td>
              </tr>
            ) : (
              profiles.map((profile) => (
                <tr key={profile.id}>
                  <td>{profile.id}</td>
                  <td>{profile.first_name}</td>
                  <td>{profile.last_name || '—'}</td>
                  <td>
                    {profile.social_link ? (
                      <a href={profile.social_link} target="_blank" rel="noopener noreferrer">
                        {profile.social_link.length > 40 ? profile.social_link.substring(0, 40) + '...' : profile.social_link}
                      </a>
                    ) : (
                      '—'
                    )}
                  </td>
                  <td>{profile.technology || '—'}</td>
                  <td>{profile.login}</td>
                  <td>
                    <button
                      className="btn-icon btn-edit"
                      onClick={() => handleEdit(profile)}
                      title="Редактировать"
                    >
                      ✏️
                    </button>
                    <button
                      className="btn-icon btn-delete"
                      onClick={() => handleDelete(profile.id)}
                      title="Удалить"
                    >
                      ✕
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default MentorProfilesSubTab;
